import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import LFLB from './LFLB'

function App() {
  return (
    <Router>
        <Route path='/present/:appId/lflb' render={(props) =>
          <LFLB
          {...props} />} />
    </Router>
  )
}

export default App
